/**
 * Plugin that exposes $socket (a simple event bus) in every Vue component we use
 * @module Plugin/Socket
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Session from "../session";
import * as Peers from "../peers";
export default {
    install: function (Vue, options) {
        var readyPromise = new Promise(function (resolve, reject) {
            var $socket = {
                session: null,
                bus: new Vue(),
                open: function (userName) {
                    var _this = this;
                    // establish websocket connection
                    this.session = Session.init({
                        username: userName,
                        onClose: function () {
                            options.store.dispatch("clearPeers");
                            Peers.closeAll();
                            Peers.removeAll();
                        },
                        getAppState: function () {
                            return options.store.getters.appState;
                        },
                    }, Session.receive(this.bus.$emit.bind(this.bus)));
                    // this.session.socket is the real socket here
                    this.session.socket.onerror = function (error) {
                        if (typeof options.onError === "function") {
                            options.onError(error);
                            return;
                        }
                        throw error;
                    };
                    // set session guid and resolve readyPromise when connection
                    // is established and we get a response from server
                    this.bus.$on("joinPeerResponse", function (payload) {
                        if (payload.sessionGuid) {
                            _this.session.sessionGuid = payload.sessionGuid;
                        }
                        if (payload.chatEnabled) {
                            options.store.dispatch("enableChat", { peersIdentifier: payload.peersIdentifier });
                        }
                        else {
                            options.store.dispatch("disableChat");
                        }
                        if (payload.supportMusic) {
                            options.store.dispatch("updateSupportMusic", true);
                        }
                        if (payload.supportSimultaneousScreen) {
                            options.store.dispatch("updateSupportSimultaneousScreen", true);
                        }
                        if (payload.iceServers) {
                            _this.session.iceServers = payload.iceServers.map(function (entry) {
                                return entry.url.startsWith("turn:")
                                    ? {
                                        urls: [entry.url],
                                        username: entry.turnUsername,
                                        credential: entry.turnPassword,
                                    }
                                    : { urls: [entry.url] };
                            });
                        }
                        resolve({
                            session: _this.session,
                            socket: _this.session.socket,
                        });
                    });
                },
                on: function (message, listener) {
                    this.bus.$on(message, listener);
                },
                send: function (message, payload) {
                    Session.send(this.session, message, payload);
                },
                sendWithoutSession: function (action, payload) {
                    var messageJson = JSON.stringify(__assign({ action: action }, payload));
                    this.session.socket.send(messageJson);
                },
                whenReady: function () {
                    return readyPromise;
                },
            };
            Vue.prototype.$socket = $socket;
        });
    },
};



//////////////////
// WEBPACK FOOTER
// ./src/plugin/socket.ts
// module id = 137
// module chunks = 1